import styled from 'styled-components'

export const Table = styled.table`
  td,
  tbody > tr > th {
    padding: 5px;
  }
`
